import { modifier } from 'ember-modifier';

export default modifier(() => {
  if (window.intercomSettings) {
    window.intercomSettings = { ...window.intercomSettings, hide_default_launcher: true };
  }

  return () => {
    if (window.intercomSettings) {
      window.intercomSettings = { ...window.intercomSettings, hide_default_launcher: false };
    }
  };
});
